import React, { useState, useEffect } from "react";
import "./newf.css";
import usePasswordToggle from "./usePasswordToggle";
import PasswordStrengthIndicator from "./PasswordStrengthIndicator/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { auth, db } from "../firebase";
import { Text } from "../containers/Language";
import { Helmet } from 'react-helmet';

const isNumberRegx = /\d/;
const specialCharacterRegx = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

export default function SignIn() {
  const history = useHistory("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [PasswordInputType, ToggleIcon] = usePasswordToggle();
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [passwordValidity, setPasswordValidity] = useState({
    minChar: null,
    number: null,
    specialChar: null,
  });

  const onChangePassword = (password) => {
    setPassword(password);

    setPasswordValidity({
      minChar: password.length >= 8 ? true : false,
      number: isNumberRegx.test(password) ? true : false,
      specialChar: specialCharacterRegx.test(password) ? true : false,
    });
  };

  const register = (event) => {
    event.preventDefault();
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        if (auth.user) {
          auth.user
            .updateProfile({
              displayName: firstName + " " + lastName,
            })
            .then((s) => {
              db.collection("users")
                .doc(auth.user.uid)
                .set({
                  uid: auth.user.uid,
                  displayName: auth.user.displayName,
                  email: auth.user.email,
                  bio: "",
                })
                .then((r) => {
                  history.push("/");
                });
            });
        }
      })
      .catch((e) => {
        if (e.message === "Please double check your password!") {
          alert("Please check your credentials again");
        } else if (
          e.message ===
          "There is no user record corresponding to this identifier. The user may have been deleted."
        ) {
          history.push("/login");
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: "smooth",
          });
        } else {
          alert(e.message);
        }
      });
  };

  return (
    <div className="row justify-content-center">
    <Helmet>
    <title> Register to use worldCom! </title>
  </Helmet>
      <div className="col-lg-6 text-center">
        <div className="card11 bg-light">
          <article className="card-body mx-auto" style={{ maxWidth: "400px" }}>
            <h4 className="card-title_courses mt-3 text-center">
              <Text tid="Registration_page_title" />
            </h4>
            <p className="text-center">
              <Text tid="Registration_page" />
            </p>
            <form>
              <div className="form-group input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon="user" />
                  </span>
                </div>
                <input
                  name=""
                  className="form-control"
                  placeholder="First name"
                  type="text"
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                  required
                />
              </div>

              <div className="form-group input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon="user" />
                  </span>
                </div>
                <input
                  name=""
                  className="form-control"
                  placeholder="Last name"
                  type="text"
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                  required
                />
              </div>

              <div className="form-group input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon="envelope" />
                  </span>
                </div>
                <input
                  name=""
                  className="form-control"
                  placeholder="Email address"
                  type="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                />
              </div>

              <div className="form-group input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <FontAwesomeIcon icon="lock" />
                  </span>
                </div>
                <input
                  className="form-control"
                  placeholder="Create password"
                  type={PasswordInputType}
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                  onFocus={() => setPasswordFocused(true)}
                  onChange={(e) => onChangePassword(e.target.value)}
                  required
                />
                <span className="password-toogle-icon">{ToggleIcon}</span>
              </div>

              {passwordFocused && (
                <PasswordStrengthIndicator validity={passwordValidity} />
              )}

              <div className="form-group">
                <button
                  type="submit"
                  onClick={register}
                  required
                  className="btn btn-primary btn-block"
                  required
                >
                  {" "}
                  <Text tid="Sign_up_account" />
                </button>
              </div>
              <p className="text-center">
                <Text tid="Sign_up_have_an_account_" />
                <a href="/login">
                  <Text tid="Sign_up_have_an_account_here" />
                </a>{" "}
              </p>
            </form>
          </article>
        </div>
      </div>
    </div>
  );
}
